import React, { useState, useEffect, useCallback } from "react";
import { Row, Card, Col, Button, Modal } from "react-bootstrap";
import ApiAmusementService from "../../../../core/api/api.amusementService";
import PagingSmall from "../../_Components/PagingSmall";
import SelectImageModal from "../../Gallery/SelectImageModal";
import AddCircle from "@mui/icons-material/AddCircleRounded";
import SwalMessage from "../../_Components/SwalMessage";
import Swal from "sweetalert2";
import SwapVert from "@mui/icons-material/SwapVert";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
function ShowImages(props) {
  const [listData, setListData] = useState();

  const [dataForListDataPgination, setDataForListDataPgination] = useState({});

  useEffect(() => {
    (async () => {
      try {
        const apiData = await ApiAmusementService.getAllAmusementServiceSlider({
          amusementServiceId: props.amusementServiceId,
          pageSize: 200,
        });
        if (apiData.succeeded) {
          setListData(apiData?.data.reverse().sort((a, b) => a.viewOrder - b.viewOrder));
        }
      } catch (error) {
      } finally {
      }
    })();
    return () => { };
  }, []);

  // --------------------------------دریافت اطلاعات از pagination ------------------------------------------
  const handlePagingSmallForListData = (data) => {
    setDataForListDataPgination({
      start: data.start,
      end: data.end,
    });
  };

  //----------- نمایش مدال تصاویر سامانه  ------
  const [showModalAddImag, setShowModalAddImag] = useState(false);
  const [showModalChangeImageOrder, setShowModalChangeImageOrder] = useState(false);

  const callBackSlider = async (data) => {
    // ارسال جهت درج
    const apiData2 = await ApiAmusementService.createAmusementServiceSlider({
      amusementServiceId: props.amusementServiceId,
      listGalleryId: data,
    });
    if (apiData2.succeeded) {
      SwalMessage({ title: apiData2.message, iSsuccess: apiData2.succeeded });
    }
    //رفرش تصاویر
    const apiData = await ApiAmusementService.getAllAmusementServiceSlider({
      amusementServiceId: props.amusementServiceId,
      pageSize: 200,
    });
    if (apiData.succeeded) {
      setListData(apiData.data);
    }
  };

  async function DeleteIMG(item) {
    Swal.fire({
      title: "حذف تصویر",
      text: "این تصویر حذف شود؟",
      showDenyButton: true,
      icon: "question",
      // showCancelButton: true,
      confirmButtonText: "بله",
      denyButtonText: "خیر",
      // cancelButtonText: 'انصراف',
      customClass: {
        actions: "my-actions",
        cancelButton: "order-1 right-gap btn btn-secondary",
        confirmButton: "order-2 btn btn-success px-5",
        denyButton: "order-3 btn btn-danger px-5",
      },
      focusCancel: true
    }).then((result) => {
      if (result.isConfirmed) {
        deleteApi(item.amusementServiceSliderId);
      } else if (result.isDenied) {
        //Swal.fire('Changes are not saved', '', 'info')
      }
    });
  }

  const deleteApi = async (id) => {
    const apiData2 = await ApiAmusementService.deleteAmusementServiceSlider({ id: id });

    if (apiData2.succeeded) {
      const apiData = await ApiAmusementService.getAllAmusementServiceSlider({
        amusementServiceId: props.amusementServiceId,
        pageSize: 200,
      });
      if (apiData.succeeded) {
        setListData(apiData.data);
        // setValue("totalCount", apiData.totalCount);
      }
    }
    SwalMessage({ title: apiData2.message, iSsuccess: apiData2.succeeded });
  };

  const handleDragEnd = useCallback(
    (result) => {
      if (!result.destination) return;
      const updatedListData = Array.from(listData);
      const [reorderedItem] = updatedListData.splice(result.source.index, 1);
      updatedListData.splice(result.destination.index, 0, reorderedItem);
      setListData(updatedListData);
    },
    [listData],
  );

  // send api request to change the order of images
  const changeImageOrderHandler = async () => {
    try {
      const listOfImagesId = listData.map((item) => ({ id: item.amusementServiceSliderId }));
      const data = {
        Sliders: listOfImagesId,
      };
      const response = await ApiAmusementService.changeOrderAmusementServiceSlider(data);
      SwalMessage({ title: response.message, iSsuccess: response.succeeded });
    } catch (error) {
    }
  };
  return (
    <div className={`card card-custom px-4 mt-4 bg-light`}>
      {showModalAddImag && (
        <SelectImageModal
          option={1}
          type={1}
          selectedId={props.amusementServiceId}
          show={setShowModalAddImag}
          callBack={callBackSlider}
        />
      )}

      <Row className="border-top px-4">
        <Col xs="12" className="mb-1">
          <h5 className="mt-5">عکس های وابسته به سرویس</h5>
          <Button
            variant="primary"
            className="mt-4 "
            size="sm"
            onClick={(event) => {
              if (props.amusementServiceId != 0)
                setShowModalAddImag(!showModalAddImag)
              else
                SwalMessage({ title: "ابتدا سرویس مورد نظر را اضافه کنید" });
            }}
          >
            <AddCircle className="mr-1" />
            افزودن عکس
          </Button>

          <Button
            variant="success"
            className="mt-4 ml-5"
            size="sm"
            onClick={(event) =>
              setShowModalChangeImageOrder(true)
            }
          >
            <SwapVert className="mr-1" />
            مرتب سازی عکس
          </Button>
        </Col>
        <Col xs="12" className="mt-2">
          {listData?.length > 0 ? (
            <Row className="d-flex flex-wrap justify-content-center mt-1 ">
              {listData?.slice(dataForListDataPgination.start, dataForListDataPgination.end).map((item, index) => (
                <Card style={{ width: "15rem" }} key={index} className="mb-2  mt-4 mx-1">
                  {item.option == 1 || item.option == 3
                    ? <Card.Img
                      variant="top"
                      title={item.imageAlt}
                      src={process.env.REACT_APP_MEDIA_URL + item.imageUrl}
                      alt={item.imageAlt}
                      height="140px"
                      className="bg-light-primary"
                    />
                    : <video
                      width="100%"
                      height="100%"
                      style={{ maxHeight: 200 }}
                      src={process.env.REACT_APP_MEDIA_URL + item.imageUrl}
                      alt={item.imageAlt}
                    />
                  }

                  <Card.Body className=" py-0 px-0 ">
                    <Row>
                      <Col xs="9" className="  ">
                        <small className="h-100  ml-2  "> {item.imageAlt} </small>
                      </Col>
                      <Col xs="3" className=" ">
                        <Button variant="none" className="mt-1 pr-2" size="sm" onClick={(event) => DeleteIMG(item)}>
                          <small className="fas fa-trash-alt cursor-pointer"></small>
                        </Button>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              ))}
            </Row>
          ) : (
            <p>تصویری برای این جستجو پیدا نشد .</p>
          )}
        </Col>
        <Col xs="12" className="mt-2">
          <Row className="d-flex flex-wrap justify-content-center mt-1 ">
            <PagingSmall
              callBack={handlePagingSmallForListData}
              data={{
                activePage: 1,
                sizePage: 4,
                totalItems: listData?.length,
              }}
            />
          </Row>
        </Col>

        <Modal centered size="md" onHide={() => setShowModalChangeImageOrder(false)} show={showModalChangeImageOrder}>
          <Modal.Header closeButton>
            <Modal.Title> تغییر ترتیب تصاویر</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <DragDropContext onDragEnd={handleDragEnd}>
              <Droppable droppableId="droppable">
                {(provided) => (
                  <ul className="sortable-list" {...provided.droppableProps} ref={provided.innerRef}>
                    {listData.map((item, index) => (
                      <Draggable key={index} draggableId={index.toString()} index={index}>
                        {(provided) => (
                          <li
                            className="sortable-item d-flex justify-content-center mb-5"
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            <Card style={{ width: "15rem" }} key={index} className="mb-2">
                              <Card.Img
                                variant="top"
                                title={item.imageAlt}
                                src={process.env.REACT_APP_MEDIA_URL + item.imageUrl}
                                alt={item.imageAlt}
                                className="bg-light-primary"
                              />
                              <Card.Body className=" py-0 px-0 ">
                                <Row>
                                  <Col xs="9" className="  ">
                                    <small className="h-100  ml-2  "> {item.imageAlt} </small>
                                  </Col>
                                </Row>
                              </Card.Body>
                            </Card>
                          </li>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </ul>
                )}
              </Droppable>
            </DragDropContext>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" onClick={changeImageOrderHandler}>
              <SaveIcon /> ذخیره
            </Button>
            <Button variant="danger" onClick={() => setShowModalChangeImageOrder(false)}>
              <CloseIcon /> بستن
            </Button>
          </Modal.Footer>
        </Modal>
      </Row>
    </div>
  );
}

export default ShowImages;
